export default __webpack_public_path__ + "static/media/paypal.e548310f.png";